import AutoComplete from './autocomplete';

function autocomplete(props) {
  return new AutoComplete(props);
}

export default autocomplete;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/autocomplete/index.js
// module id = 545
// module chunks = 9